import { z } from 'zod';

export const FormSchema = z.object({
  unit_id: z.string().nonempty('Đơn vị là bắt buộc'),
  tknh: z.string().nonempty('Mã tài khoản là bắt buộc'),
  name: z.string().nonempty('Số tài khoản là bắt buộc'),
  chu_tk: z.string().nonempty('Chủ tài khoản là bắt buộc'),
  chi_nhanh: z.string().optional().nullable(),
  ten_tknh: z.string().optional().nullable(),
  sten_tknh: z.string().optional().nullable(),
  tinh_thanh: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  fax: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),
  active: z.boolean()
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  unit_id: '',
  tknh: '',
  name: '',
  chu_tk: '',
  chi_nhanh: '',
  ten_tknh: '',
  sten_tknh: '',
  tinh_thanh: '',
  phone: '',
  fax: '',
  ghi_chu: '',
  active: true
};
